import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)

export default (data) => {

    const vm = new Vue({
        el: '#contact-content',
        data: {
            caution_public_flg: data.caution_public_flg,
            caution_message: data.caution_message,
            errors: data.errors,
        },
        methods: {
            resetErrors: function () {
                console.log("resetErrors");
                this.errors = {};
            },
        },
        computed: {
            // 必要に応じてcomputedプロパティを追加
        }
    });
}
